import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const ContrastIcon = createValidIcon((props) => {
  const { color } = props

  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2V16Z'
        fill={color}
      />
    </svg>
  )
})
